import { EFreightLoadingType, EStopStatus, EStopType, EVehicleType, ICoords, UUID } from '@okcargo-apps/shared-domain';

export interface IStopMarketForCarrier {
  id: UUID;
  position: number;
  type: EStopType; // enum
  since: Date;
  until: Date;
  status: EStopStatus; // NEW enum
  address: IAddressMarket;
}

// interface ICarrier {
//   id: number;
//   name: string;
//   taxId: string;
//   phone: string;
// }

// from DTO FreightBasicResponse
export interface IFreightMarketForCarrier {
  id: UUID;
  available: boolean; // old draft property
  reference: string;
  deliveryNoteInPaperRequired: boolean; // old deliveryNoteInPaper
  price: number;
  distance: number;
  numberOfStops: number;
  vehicleTypes: EVehicleType[];
  loadingTypes: EFreightLoadingType[];
  weight: number;
  stops: IStopMarketForCarrier[];
  instructions?: string;

  // carrier: ICarrier; // what???
  // status: EFreightStatus;
  nature: string;
  // packages: number; // not in use???
  title: string; // calculated
  // assignationId: UUID;
  // isAssigned: boolean;
  pricePerKilometer: number; // calculate
  // draft: boolean;
  // shipperCarrierAssignationId: UUID;
  // carrierCollaboratorAssignationId: UUID;
}

export function getEmptyDefaultMarketFreight(): IFreightMarketForCarrier {
  return {
    id: '',
    // carrier: {} as ICarrier,
    reference: '',
    vehicleTypes: [],
    loadingTypes: [],
    deliveryNoteInPaperRequired: false,
    instructions: '',
    numberOfStops: 0,
    // status: EFreightStatus.DEFAULT,
    stops: [],
    price: 0,
    nature: '',
    weight: 0,
    // packages: 0,
    title: '',
    distance: 0,
    pricePerKilometer: 0,
    // draft: false,
    available: true,
  };
}

export interface IAddressMarket {
  company?: string; // New, display in address component. Get this value in mapper.
  street: string;
  city: string;
  postalCode: string;
  state: string;
  stateCode: string;
  country: string;
  countryCode: string;
  coords?: ICoords; // Map from pointPayload. // Note: not needed coords in card (or pseudo-table) component
}
